import * as types from "./solicitarDocumento.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  tokenRecaptcha: "",
  HeaderDocumento: {},
  PesquisaDocumentoModalToggle: false,
  GridSolicitarDocumentoPesquisa: [],
  GridSolicitarDocumento: [],
  SuggestionSolicitarDocumento: undefined,
  SolicitacaoDocumentoPost: {
    Protocolo: undefined,
    CpfCnpjSolicitante: undefined,
    CnpjEmpresa: undefined,
    Ccm: undefined,
    IdSolicitacao: undefined,
    IdEmpresa: undefined,
    NrCnpj: undefined,
    NomeEmpresa: undefined,
    IdAnalise: undefined
  },
  GridSolicitarDocumentoResultado: {
    NrProtocolo: undefined,
    TipoDocumento: undefined,
    DataSolicitacao: undefined,
    SituacaoDocumento: undefined,
    SnNovo: undefined
  },
  ResultadoDocumentoModalToggle: false,
  recaptchaResetRefModal: undefined,
  tokenRecaptchaModal: ""
});

const reduce = (state = initialState, action = {}) => {
  const { payload } = action;
  switch (action.type) {
    case types.SET_TOKEN_RECAPTCHA:
      return state.merge({ tokenRecaptcha: payload });
    case types.TOGGLE_MODAL_PESQUISA_DOCUMENTO:
      return state.merge({ PesquisaDocumentoModalToggle: !state.PesquisaDocumentoModalToggle });
    case types.SET_GRID_PESQUISA_DOCUMENTO:
      return state.merge({ GridSolicitarDocumentoPesquisa: payload });
    case types.SET_GRID_SOLICITAR_DOCUMENTO:
      return state.merge({ GridSolicitarDocumento: payload });
    case types.SET_SOLICITACAO_DOCUMENTO_POST:
      return state.merge({ SolicitacaoDocumentoPost: payload });
    case types.SET_GRID_RESULTADO_DOCUMENTO:
      return state.merge({ GridSolicitarDocumentoResultado: payload });
    case types.RESET_SOLICITACAO_DOCUMENTO_POST:
      return state.merge({
        tokenRecaptcha: "",
        HeaderDocumento: {},
        SuggestionSolicitarDocumento: {},
        GridSolicitarDocumento: [],
        SolicitacaoDocumentoPost: {
          Protocolo: undefined,
          CpfCnpjSolicitante: undefined,
          CnpjEmpresa: undefined,
          Ccm: undefined,
          IdSolicitacao: undefined,
          IdEmpresa: undefined,
          NrCnpj: undefined,
          NomeEmpresa: undefined,
          IdAnalise: undefined
        }
      });
    case types.TOGGLE_MODAL_RESULTADO_DOCUMENTO:
      return state.merge({ ResultadoDocumentoModalToggle: !state.ResultadoDocumentoModalToggle });
    case types.SET_HEADER_DOCUMENTO:
      return state.merge({ HeaderDocumento: payload });
    case types.SET_SUGGESTION_DOCUMENTO:
      return state.merge({ SuggestionSolicitarDocumento: payload });
    case types.SET_RECAPTCHA_RESET_REF_MODAL:
      return state.merge({ recaptchaResetRefModal: payload });
    case types.SET_TOKEN_RECAPTCHA_MODAL:
      return state.merge({ tokenRecaptchaModal: payload });
    case types.MERGE_SOLICITACAO_DOCUMENTO_POST:
      return state.merge({ SolicitacaoDocumentoPost: { ...state.SolicitacaoDocumentoPost, ...payload } });
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
};

store.registerDynamicModule("redeSIM.solicitarDocumento", reduce);
